import React from 'react'

import { BrowserRouter, Route, Routes } from 'react-router-dom'

import UseScrollToTop from '@hooks/useScrollToTop'

import DeleteAccount from '@pages/DeleteAccount'
import Main from '@pages/Main'
import Pp from '@pages/Pp'
import TosFull from '@pages/TosFull'
import TosProvider from '@pages/TosProvider'

function RoutesComponent() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <UseScrollToTop />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/index.html" element={<Main />} />
        <Route path="/pp.html" element={<Pp />} />
        <Route path="/tos-full.html" element={<TosFull />} />
        <Route path="/tos-provider.html" element={<TosProvider />} />
        <Route path="/delete-account.html" element={<DeleteAccount />} />
        <Route path="*" element={<h1>Not Found</h1>} />
      </Routes>
    </BrowserRouter>
  )
}

function App() {
  return <RoutesComponent />
}

export default App
